import React from 'react';
import clsx from 'clsx';

import { countries } from 'utils/formData';
import { texts } from 'utils/languages/fr';

import { NativeDatePicker, CustomSelect, BasicTableCellAddressForm } from 'components';
import { TableCell, MenuItem, InputBase } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    flexContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    tableCell: {
        border: '1px solid #ccc',
        textAlign: 'center',
        padding: 0,
        margin: 0,
        height: 1,
        minWidth: 150,
    },
    input: {
        padding: 0,
        margin: 0,
        minHeight: 65,
        height: '100%',
        width: '100%',
    },
    dateInput: {
        flexDirection: 'row',
        marginBottom: 0,
        height: '100%',
        borderBottom: `1px solid ${theme.palette.common.black}`,
        padding: theme.spacing(),
    },
    textInput: {
        padding: '0px 5px',
        margin: 0,
        minHeight: 65,
        borderBottom: '1px solid #0000006b',
        width: '100%',
        height: '100%',
    },
    textInputHover: {
        '&:hover': {
            borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
    },
    selectInput: {
        marginBottom: 0,
        height: '100%',
    },
    error: {
        border: `2px solid ${theme.palette.error.main}`,
    },
    registrationTableCell: {
        minWidth: 450,
        borderBottom: '1px solid #0000006b',
        '&:hover': {
            borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
    },
    registrationRadioGroup: {
        padding: 16,
        flexDirection: 'column',
        textAlign: 'left',
    },
    disabled: {
        backgroundColor: ' #F8F8F8',
    },
}));

const renderOption = opt => (
    <MenuItem key={opt.id} value={opt.id}>
        {opt.name}
    </MenuItem>
);

export const CommonPPTableRows = ({
    values: { lastname, firstname, address, birthDate, cityOfBirth, nationality, nif },
    handleChange,
    handleAddressChange,
    handleDateChange,
    hasNationality,
    hasNIF,
    errors,
}) => {
    const classes = useStyles();
    return (
        <>
            <TableCell classes={{ root: classes.tableCell }}>
                <InputBase
                    className={clsx(
                        classes.textInput,
                        errors?.lastname ? classes.error : classes.textInputHover
                    )}
                    name="lastname"
                    onChange={handleChange}
                    value={lastname}
                    multiline
                />
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }}>
                <InputBase
                    className={clsx(
                        classes.textInput,
                        errors?.firstname ? classes.error : classes.textInputHover
                    )}
                    name="firstname"
                    onChange={handleChange}
                    value={firstname}
                    multiline
                />
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }}>
                <BasicTableCellAddressForm
                    onAddressChange={handleAddressChange}
                    address={address}
                    placeholder={texts.ADRESSE_DU_DOMICILE_PERSONNEL}
                />
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }}>
                <NativeDatePicker
                    className={classes.dateInput}
                    name="birthDate"
                    handleDateChange={handleDateChange}
                    value={birthDate}
                />
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }}>
                <InputBase
                    className={clsx(classes.textInput, classes.textInputHover)}
                    name="cityOfBirth"
                    onChange={handleChange}
                    value={cityOfBirth}
                    multiline
                />
            </TableCell>
            {hasNationality && (
                <TableCell classes={{ root: classes.tableCell }}>
                    <CustomSelect
                        inputStyle={classes.selectInput}
                        className={classes.input}
                        name="nationality"
                        onChange={handleChange}
                        value={nationality}
                        variant="standard"
                    >
                        {countries.map(renderOption)}
                    </CustomSelect>
                </TableCell>
            )}
            {hasNIF && (
                <TableCell classes={{ root: classes.tableCell }}>
                    <InputBase
                        className={clsx(classes.textInput, classes.textInputHover)}
                        name="nif"
                        onChange={handleChange}
                        value={nif}
                        multiline
                    />
                </TableCell>
            )}
        </>
    );
};
